import { ACCENT_BLUE, NOPING_GREEN } from '../constants';

const STREAKS = [
  { top: 20, width: 150, color: NOPING_GREEN, duration: 2, delay: 0 },
  { top: 40, width: 200, color: ACCENT_BLUE, duration: 2.4, delay: 0.7 },
  { top: 60, width: 250, color: NOPING_GREEN, duration: 2.8, delay: 1.4 },
  { top: 80, width: 300, color: ACCENT_BLUE, duration: 3.2, delay: 2.1 },
];

export function SpeedStreaks() {
  return (
    <div className='pointer-events-none absolute inset-0 overflow-hidden' aria-hidden='true'>
      {STREAKS.map((s, i) => (
        <div
          key={i}
          className='v2a-speed-streak absolute start-0 h-px'
          style={{
            top: `${s.top}%`,
            width: `${s.width}px`,
            background: `linear-gradient(90deg, transparent, ${s.color}, transparent)`,
            animation: `v2a-speed-streak ${s.duration}s ease-in-out infinite ${s.delay}s`,
            opacity: 0.3,
          }}
        />
      ))}
      {/* The streak is parked on the inline-start edge, which `start-0` already mirrors — but the flight
          is a `transform`, and CSS never mirrors those for writing direction. Left alone, on /sa the
          streak starts at the RIGHT edge and then flies another 100vw further right, off screen: it is
          visible for 7 of 21 sampled frames against 15 in LTR. The mirrored keyframes fly it the other
          way, so both directions sweep across the viewport instead of away from it.

          `!important` is load-bearing: each streak carries its own duration and delay, so the
          `animation` shorthand stays on the element's inline `style`, and an inline declaration
          outranks every stylesheet rule without it. */}
      <style
        dangerouslySetInnerHTML={{
          __html: '@keyframes v2a-speed-streak { 0% { transform: translateX(-100%) scaleX(0.3); opacity: 0; } 30% { opacity: 1; } 100% { transform: translateX(100vw) scaleX(0.3); opacity: 0; } } @keyframes v2a-speed-streak-rtl { 0% { transform: translateX(100%) scaleX(0.3); opacity: 0; } 30% { opacity: 1; } 100% { transform: translateX(-100vw) scaleX(0.3); opacity: 0; } } [dir="rtl"] .v2a-speed-streak { animation-name: v2a-speed-streak-rtl !important; }',
        }}
      />
    </div>
  );
}
